import Vue from 'vue';
import 'src/material/global/vendor/chart-js/Chart.min';
import moment from 'moment';
import rentalService from './../../../services/rental';
import analyticsService from '../../../services/analytics';
import mixin from './../../../mixins/mixin';
import accountService from '../../../services/account';

export default {
  data() {
    return {
      rentals: [],
      selectedRental: {},
      year: moment().format('YYYY'),
      month: moment().format('M'),
      loading: true,
      reviewsComments: [],
      groups: [],
      checkedRentals: {},
      checkedGroups: {},
      others: [],
      reviewsUrls: [],
      hasReviewsUrls: false,
      language: localStorage.getItem('lang') || 'fr',
      alertLows: {
        booking: '',
        expedia: '',
        google: '',
        airbnb: '',
      },
      isFromMounted: false,
      accessToTabsStatus: {
        general: false,
        rentals: false,
        reviews: false,
        environment: false,
        market: false,
        analyses: false,
      },
      avgReviews: {
        booking: {
          avgRate: 0,
          reviews: 0,
        },
        airbnb: {
          avgRate: 0,
          reviews: 0,
        },
        expedia: {
          avgRate: 0,
          reviews: 0,
        },
        google: {
          avgRate: 0,
          reviews: 0,
        },
      },
      requestRentalData: [],
      yearRange: [],
      smallLoading: false,
      selectedRentalId: null
    };
  },
  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),
    VLoading: require('components/loading/loading.vue'),
    VExportAnalysis: require('components/export-analysis/export-analysis.vue'),
    VGenerateConcierge: require('components/generate-concierge/Concierge'),
    VGenerateAnalyses: require('components/generate-analyses/index.vue'),
    VGenerateExtractor: require('components/generate-extractor/index.vue'),
    VGenerateCityTaxes: require('components/city-taxes/CityTaxesModal.vue'),
  },
  mixins: [mixin],
  methods: {
    new_rental() {
      Vue.router.push({
        name: 'rentals.create',
      });
    },
    async get_rental_reviews_data(year, month, rentals = []) {
      let url = '';
      this.loading = true;
      url = `/get-data-for-reviews?rentals=${rentals}`;
      url += year.length > 0 ? `&year=${year}` : '';
      url += month.length > 0 ? `&month=${month}` : '';

      await analyticsService.getReviewsTab(url, this);
    },
    change_tab(tab) {
      const vm = this;
      const params = {};
      if (vm.rentals.length > 0) {
        params.id = vm.rentals[0].id;
      }
      if (tab == 'market') {
        params.start = moment().format('Y-MM-DD');
        params.end = moment().add(30, 'days').format('Y-MM-DD');
      }
      Vue.router.push({
        name: `analytics.${tab}.tab`,
        params: tab !== 'general' && params,
      });
    },
    async saveReviews() {
      this.smallLoading = true;
      const reviews = {
        booking_url: this.selectedRental.booking_url,
        expedia_url: this.selectedRental.expedia_url,
        google_url: this.selectedRental.google_url,
        airbnb_url: this.selectedRental.airbnb_url,
      };
      await rentalService.updateReviews(this.selectedRental.id, reviews, this);
      await this.get_rental_reviews_data(this.year, this.month);
      await this.getReviewsUrls();
    },
    async saveAlerts() {
      const vm = this;

      const alerts = {
        booking_alert: vm.selectedRental.booking_alert,
        expedia_alert: vm.selectedRental.expedia_alert,
        google_alert: vm.selectedRental.google_alert,
        airbnb_alert: vm.selectedRental.airbnb_alert,
      };

      await rentalService.updateAlerts(vm, alerts, vm.selectedRental.id);
    },
    getOtherRentals() { // get rentals which are not in any groups
      const vm = this;
      const removed = [];
      const isGroups = vm.groups.length > 0;
        // if there are not groups then all rentals will be in 'others' group
      if (!isGroups) {
        const group = {
          id: 0,
          name: this.$t('groups.all'),
          rentals: vm.others,
        };
        Vue.set(vm.groups, vm.groups.length, group);
      }
      for (let i = 0; i < vm.rentals.length; i++) {
        const rental = vm.rentals[i];
        for (let j = 0; j < vm.groups.length; j++) {
          const group = vm.groups[j];
          const check = group.rentals.filter(r => r.id === rental.id);
          if (check.length > 0) {
            const check1 = vm.others.filter(r => r.id === rental.id);
            if (check1.length > 0) {
              const index = vm.others.indexOf(rental);
              vm.others.splice(index, 1);
              break;
            }
            removed.push(rental);
          } else {
            const check2 = vm.others.filter(r => r.id === rental.id);
            if (check2.length === 0 && !removed.includes(rental)) {
              vm.others.push(rental);
            }
          }
        }
      }
        // add group with rentals which are not in any groups
      if (isGroups) {
        const group = {
          id: 0,
          name: this.$t('groups.others'),
          rentals: vm.others,
        };
        Vue.set(vm.groups, vm.groups.length, group);
      }
      return vm.others;
    },
    filterByRentals(id = null) {
      const vm = this;
      const requestRentals = [];

      if (id != null) {
        const group = vm.groups.filter(g => g.id === id)[0];
        const groupRentals = group.rentals;
        for (let i = 0; i < groupRentals.length; i++) {
          Vue.set(vm.checkedRentals, groupRentals[i].id, vm.checkedGroups[id]);
        }
      }
      for (let i = 0; i < vm.groups.length; i++) {
        const group = vm.groups[i];
        for (let j = 0; j < group.rentals.length; j++) {
          const rental = group.rentals[j];
          if (!vm.checkedRentals[rental.id]) {
            Vue.set(vm.checkedGroups, group.id, false);
            break;
          }
          Vue.set(vm.checkedGroups, group.id, true);
        }
      }
      for (const k in vm.checkedRentals) {
        if (vm.checkedRentals[k] === true) {
          requestRentals.push(parseInt(k));
        }
      }
      this.requestRentalData = [...requestRentals];
      vm.get_rental_reviews_data(vm.year, vm.month, requestRentals);
    },
    getReviewsUrls() {
      this.hasReviewsUrls = false;
      for (let i = 0; i < this.reviewsUrls.length; i++) {
        const url = this.reviewsUrls[i];
        if (url.booking_url || url.expedia_url || url.google_url || url.airbnb_url) {
          this.hasReviewsUrls = true;
          this.loading = false;
          return;
        }
      }
      this.loading = false;
    },
    fillSelectedRental() {
        this.selectedRental = {...this.rentals.find(rental => rental.id === this.selectedRentalId)};
    },
    addReviews() {
      if (this.rentals[0]) {
        this.selectedRentalId = this.rentals[0].id;
        this.selectedRental = {...this.rentals[0]};
      }
      this.openModal('#add-reviews');
    },
    addAlerts() {
      if (this.rentals[0]) {
        this.selectedRentalId = this.selectedRentalId ? this.selectedRentalId : this.rentals[0].id;
        this.fillSelectedRental();
      }
      this.openModal('#add-alerts');
    },
    reviewIncludePosNegComment(comment) {
      return comment.includes('(+)')  || comment.includes('(-)')
    }
  },
  async mounted() {
    mixpanel.track('web.analytics.reviews');
    this.loading = true;
    for (let i = 2015; i <= moment().add(2, 'years').year(); i++) {
      this.yearRange.push(i);
    }
    await accountService.fetchUserAccount(this);
    await this.checkAccessToTabs(this);
    rentalService.getAll(this, true);
    this.isFromMounted = true;
    await this.get_rental_reviews_data(this.year, this.month);
    await rentalService.getGroups(this, false, true);
    await this.getOtherRentals();
    await this.getReviewsUrls();
  },
  computed: {
    account() {
      return this.$store.state.account;
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/analytics/reviews/reviews.js